/**
 * Selector: Where to position the tour card.
 * Content : Content to display 
 */
export const TourSteps = [
    {
        selector: "#ace-editor",
        content: "This is the editor. You can create 3D scenes using JavaScript " +
            "and a special set of instructions or functions to MYR.\nThe editor can be " +
            "toggled on and off by opening the settings menu in the top right and " +
            "clicking the \"View Editor\" switch."
    },
    {
        selector: "#play-btn",
        content: "The Play button will render the scene."
    },
    {
        selector: "#stop-btn",
        content: "The Stop button will stop the scene. \nUse this to save battery."
    },
    {
        selector: "#scene",
        content: "The View is where you can see your work. " +
            "You can navigate the scene with the following controls: \n" +
            "W: Forward \n" +
            "A: Left\n" +
            "S: Backward\n" +
            "D: Right\n" +
            "Space: Fly Upwards\n" +
            "Shift: Fly Downwards\n" +
            "To view the scene in VR, click the goggles!"
    },
    {
        selector: "#new-btn",
        content: "Create a new scene from scratch. Be sure to save first!",
    },
    {
        selector: "#save-btn",
        content: "Save your work.",
    },
    {
        selector: "#open-btn",
        content: "See previous work and view examples.",
    },
    {
        selector: "#ref-btn",
        content: "Use the Reference to see all MYR has to offer.",
    },
    {
        selector: "#configure-scene",
        content: "Modify and share your scene including setting the background color, enabling the grid, and hiding the editor pane.",
    },
    {
        selector: "#select-course",
        content: "View the list of available courses to get you started on using MYR.",
    },
    {
        selector: "#user",
        content: "You can log in with a Google account in order to save your scenes.",
    },
    {
        selector: "#keyboard-shortcut",
        content: "View all of the keyboard shortcuts available to you."
    },
    {
        selector: "#font-size",
        content: "Change the font size within the editor."
    }
];